import { PlaybackState } from "./types"

export function isPlaying(playbackState: PlaybackState) {
  return (
    playbackState === PlaybackState.Playing ||
    playbackState === PlaybackState.Buffering
  )
}
